import { ENVIRONMENT_DEFINITION_PATH, ORGANIZATION_DISCOVERY_PATH } from '../auth.constants'

// Called before the login sequence checks the stored token: an expired token sent with them makes
// the backend answer 401, which fails app startup instead of refreshing or redirecting to login.
const PRE_LOGIN_PATHS = [`/${ENVIRONMENT_DEFINITION_PATH}`]
const PRE_LOGIN_PATH_PREFIXES = [`/${ORGANIZATION_DISCOVERY_PATH}/`]

export function attachesAccessToken(url: string, baseUrl: string): boolean {
  const normalizedUrl = url.toLowerCase()
  const normalizedBaseUrl = baseUrl.toLowerCase().replace(/\/+$/, '')
  if (!normalizedUrl.startsWith(normalizedBaseUrl)) {
    return false
  }
  const path = normalizedUrl.slice(normalizedBaseUrl.length).split(/[?#]/)[0].replace(/^\/+/, '/')
  const isPreLoginRequest =
    PRE_LOGIN_PATHS.includes(path) ||
    PRE_LOGIN_PATH_PREFIXES.some((prefix) => path.startsWith(prefix))
  return !isPreLoginRequest
}
